import { render, staticRenderFns } from "./ChartersRequestModule.vue?vue&type=template&id=5badcaa0&"
import script from "./ChartersRequestModule.ts?vue&type=script&lang=ts&"
export * from "./ChartersRequestModule.ts?vue&type=script&lang=ts&"
import style0 from "./ChartersRequestModule.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports